<template>
  <nav v-if="paginas.length > 1" class="paginacao" aria-label="Paginação dos resultados">
    <button
      type="button"
      class="paginacao__passo"
      :disabled="pagina === 1"
      @click="emit('ir', pagina - 1)"
    >
      <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M15 6l-6 6 6 6" />
      </svg>
      <span class="paginacao__passo-rotulo">Anterior</span>
    </button>

    <ul class="paginacao__numeros">
      <li v-for="numero in paginas" :key="numero">
        <button
          type="button"
          class="paginacao__numero"
          :class="{ 'paginacao__numero--ativa': numero === pagina }"
          :aria-current="numero === pagina ? 'page' : undefined"
          :aria-label="`Página ${numero}`"
          @click="emit('ir', numero)"
        >
          {{ numero }}
        </button>
      </li>
    </ul>

    <button
      type="button"
      class="paginacao__passo"
      :disabled="pagina >= ultimaPagina"
      @click="emit('ir', pagina + 1)"
    >
      <span class="paginacao__passo-rotulo">Próxima</span>
      <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M9 6l6 6-6 6" />
      </svg>
    </button>
  </nav>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    pagina: {
      type: Number,
      default: 1
    },
    /*
     * Maior pagina ja descoberta. A API nao devolve o total, entao a numeracao
     * cresce conforme o usuario avanca e para onde o catalogo acaba.
     */
    paginasConhecidas: {
      type: Number,
      default: 1
    }
  });

  const emit = defineEmits(['ir']);

  const ultimaPagina = computed(() => Math.max(props.paginasConhecidas, props.pagina));

  const paginas = computed(() => Array.from(
    { length: ultimaPagina.value },
    (item, indice) => indice + 1
  ));
</script>

<style scoped>
  .paginacao {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: var(--espaco-2);
    margin-top: var(--espaco-6);
  }

  .paginacao__passo {
    display: inline-flex;
    align-items: center;
    gap: var(--espaco-2);
    padding: var(--espaco-2) var(--espaco-3);
    border-radius: var(--raio-pilula);
    color: var(--cor-marca);
    font-size: 0.82rem;
    font-weight: 700;
    transition: background var(--transicao-padrao), color var(--transicao-padrao);
  }

  .paginacao__passo:hover:not(:disabled) {
    background: var(--cor-marca-clara);
  }

  .paginacao__passo:disabled {
    cursor: default;
    color: var(--cor-texto-tenue);
  }

  .paginacao__passo-rotulo {
    display: none;
  }

  .paginacao__numeros {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--espaco-2);
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .paginacao__numero {
    min-width: 38px;
    padding: var(--espaco-2);
    border-radius: var(--raio-pequeno);
    border: 1px solid var(--cor-linha);
    background: var(--cor-superficie);
    color: var(--cor-texto-suave);
    font-size: 0.85rem;
    font-weight: 700;
    transition: background var(--transicao-padrao), color var(--transicao-padrao), border-color var(--transicao-padrao);
  }

  .paginacao__numero:hover {
    border-color: var(--cor-marca);
    color: var(--cor-marca);
  }

  .paginacao__numero--ativa {
    background: var(--cor-marca);
    border-color: var(--cor-marca);
    color: #fff;
  }

  @media (min-width: 640px) {
    .paginacao__passo-rotulo {
      display: inline;
    }
  }
</style>
